<template>
  <v-container fluid class="d-flex align-center justify-center fill-height">
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="8" md="4">
        <v-card class="pa-5" elevation="3">
          <v-card-title class="text-center">Register</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                  label="Username"
                  prepend-icon="mdi-account"
                  v-model="username"
                  :rules="[rules.required,rules.username]"
                  required
              ></v-text-field>

              <v-text-field
                  label="Email"
                  prepend-icon="mdi-email"
                  v-model="email"
                  type="email"
                  :rules="[rules.email, rules.required]"
                  required
              ></v-text-field>

              <v-text-field
                  label="Password"
                  prepend-icon="mdi-lock"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  v-model="password"
                  :type="show ? 'text' : 'password'"
                  :rules="[rules.required, rules.password]"
                  required
                  @click:append="show = !show"
              ></v-text-field>

              <v-text-field
                  label="Confirm Password"
                  prepend-icon="mdi-lock-check"
                  v-model="confirmPassword"
                  :type="show ? 'text' : 'password'"
                  :rules="[rules.required, confirmPasswordRule]"
                  required
              ></v-text-field>

              <!-- 国家下拉框 -->
              <v-select
                  :items="countries"
                  label="Country"
                  v-model="country"
                  :rules="[rules.required]"
                  item-title="name"
                  item-value="code"
                  prepend-icon="mdi-earth"
                  required
                  :loading="loadingCountries"
                  :disabled="loadingCountries"
              ></v-select>

              <v-text-field
                  label="Institution"
                  prepend-icon="mdi-school"
                  v-model="institution"
                  :rules="[rules.required]"
                  required
              ></v-text-field>

              <v-text-field
                  label="Field"
                  prepend-icon="mdi-briefcase"
                  v-model="field"
                  :rules="[rules.required]"
                  required
              ></v-text-field>

              <v-btn color="primary" class="mt-4" block @click="register">
                Register
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarSuccess" color="success" top multi-line>
      Registration successful!
      <v-btn color="white" text @click="snackbarSuccess = false">Close</v-btn>
    </v-snackbar>

    <v-snackbar v-model="snackbarError" color="error" top multi-line>
      {{ errorMessage }}
      <template v-slot:actions>
        <v-btn color="blue" variant="text" @click="snackbarError = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      show:false,
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      country: null,
      institution: '',
      field: '',
      valid: false,
      snackbarSuccess: false,
      snackbarError: false,
      errorMessage: '',
      countries:[
      "Afghanistan",
      "Albania",
      "Algeria",
      "Andorra",
      "Angola",
      "Antigua and Barbuda",
      "Argentina",
      "Armenia",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Brazil",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cabo Verde",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Central African Republic",
      "Chad",
      "Chile",
      "China",
      "Colombia",
      "Comoros",
      "Congo",
      "Costa Rica",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Eswatini",
      "Ethiopia",
      "Fiji",
      "Finland",
      "France",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Greece",
      "Grenada",
      "Guatemala",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Honduras",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Kosovo",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands",
      "Mauritania",
      "Mauritius",
      "Mexico",
      "Micronesia",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "North Macedonia",
      "Norway",
      "Oman",
      "Pakistan",
      "Palau",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Qatar",
      "Romania",
      "Russia",
      "Rwanda",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Korea",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Sweden",
      "Switzerland",
      "Syria",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "Togo",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Vatican City",
      "Venezuela",
      "Vietnam",
      "Yemen",
      "Zambia",
      "Zimbabwe"
    ],
      loadingCountries: false, // 加载状态
      rules: {
        required: value => !!value || 'Required.',
        email: value => /.+@.+\..+/.test(value) || 'E-mail must be valid.',
        username: value =>  /^[a-zA-Z0-9!@#$%^&*()_+\-=\]{};':",./?|<>]*$/.test(value) || 'Only letters, numbers, and !@#$%^&*()_+=[]{}";\':",./?|<> are allowed',
        password: value => (value && value.length >= 8) || 'Password must be at least 8 characters.',
      },
    };
  },
  computed: {
    confirmPasswordRule() {
      return value => value === this.password || 'Passwords must match.';
    },
  },
  methods: {
    async register() {
      this.$refs.form.validate();
      if (this.valid) {
        try {
          const response = await axios.post('/api/user/RegisterView/', {
            username: this.username,
            email: this.email,
            password: this.password,
            country: this.country, // 使用选择的国家代码
            institution: this.institution,
            field: this.field,
          });

          console.log('Registration successful:', response.data);
          this.snackbarSuccess = true;
          this.$router.push('/login');
        } catch (error) {
          console.error('Registration error:', error.response ? error.response.data : error.message);
          this.errorMessage = error.response?.data?.msg || 'Registration failed. Please try again.';
          this.snackbarError = true;
        }
      }
    },
    // async fetchCountries() {
    //   this.loadingCountries = true;
    //   try {
    //     const response = await axios.get('https://restcountries.com/v3.1/all');
    //     this.countries = response.data
    //       .filter(country => country.cca2 !== 'TW') // 排除台湾
    //       .map(country => ({
    //         name: country.name.common,
    //         code: country.cca2,
    //       }));
    //     this.countries.sort((a, b) => a.name.localeCompare(b.name))
    //   } catch (error) {
    //     console.error('Failed to fetch countries:', error);
    //     this.snackbarError = true;
    //     this.errorMessage = 'Failed to load country list.';
    //   } finally {
    //     this.loadingCountries = false;
    //   }
    // },
  },
  mounted() {
    //this.fetchCountries(); // 页面加载时获取国家列表
  },
};
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
